<template>
   <div class='menu-open batt-swap-page'>
       <span class="bs-icon-success"></span>
       <!-- 开通成功 -->
       <h2>{{$t('bstext.bs10')}}!</h2>
       <!-- 请尽快在蓝鲨线下门店进行激活，即可使用换电功能。激活后如需取消，请至线下服务网点进行办理。 -->
       <p>{{$t('bstext.bs11')}}</p>
       <!-- 5秒后返回 -->
       <div>{{$t('bstext.bs12',{msg:countDown})}}</div>
   </div>
</template>

<script>
import appApi from '@/utils/appApi'
export default {
   data () {
      return {
         countDown:5
      }
   },
   mounted() {
      document.title = this.$t('bstext.bs10')
      let timer=setInterval(()=>{
         this.countDown--
         if(this.countDown<1){
            this.countDown=1
            appApi.finishCabinetWeb()
            clearInterval(timer)
         }
      },1000)
   },
   methods: {}
}
</script>

<style lang='less' scoped>
.menu-open{
   text-align: center;
   span{
      margin: 64px 0 32px;
   }
   h2{
      font-size: 18px;
      font-weight: 600;
      color: #2E68F6;
      line-height: 18px;
   }
   p{
      margin: 48px 0;
      font-size: 14px;
      color: #C7CAD1;
      line-height: 21px;  
   }
   div{
      font-size: 16px;
      font-weight: 600;
      color: #F2F2F7;
      line-height: 22px;
   }
}
</style>


// WEBPACK FOOTER //
// src/components/blueshark/battswap/menu/menuopen.vue